var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMallIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.433 14.575a2.35 2.35 0 0 0 .917-1.977 2.362 2.362 0 0 0-2.195-2.236 2.352 2.352 0 0 0-1.589 4.212.235.235 0 0 0 .26.018 2.351 2.351 0 0 1 2.348 0c.082.047.184.04.259-.017zM13.434 14.766a.235.235 0 0 0-.26-.018 2.351 2.351 0 0 1-2.348 0 .235.235 0 0 0-.26.017 2.348 2.348 0 0 0-.916 1.977 2.362 2.362 0 0 0 2.195 2.236 2.353 2.353 0 0 0 1.589-4.212z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.08 5.795c0-1.88 1.576-3.726 3.537-3.902 2.334-.217 4.303 1.546 4.303 3.744",
    stroke: "#fff",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.416 8.77a1.5 1.5 0 0 1 1.499-1.54h14.17a1.5 1.5 0 0 1 1.5 1.54l-.224 8.49a5 5 0 0 1-4.998 4.868H8.637a5 5 0 0 1-4.998-4.869l-.223-8.49z",
    stroke: "#fff",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMallIcon);
export default __webpack_public_path__ + "static/media/mall_icon.0aea6d8aabd5a15cf323a30a45ef86d3.svg";
export { ForwardRef as ReactComponent };